export default __webpack_public_path__ + "static/AITracksAtSea-70131b377e22e8ce64ca13cc88a65219.png";